<script>
    import Router from 'svelte-spa-router';
    import ProjectPreview from "./project-preview/ProjectPreview.svelte";
    import Header from "../components/header/Header.svelte";
    import ProjectListing from "./project-listing/ProjectListing.svelte"
    import ParticipateModal from "../components/modals/ParticipateModal.svelte";
    import Loader from "../components/loader/Loader.svelte";
    import ExploreProjects from "./explore-projects/ExploreProjects.svelte";
    import Footer from "../components/footer/Footer.svelte";
    import LandingPage from "./landing-page/LandingPage.svelte";
    import {chainId, defaultEvmStores} from 'svelte-ethers-store'
    import {SUPPORTED_CHAIN} from "../constants/constants";
    import ChainModal from "../components/chain-modal/ChainModal.svelte";
    import Permissionless from "./permissionless/Permissionless.svelte";
    import SaleListing from "./permissionless/sale-listing/SaleListing.svelte";
    import SaleDetail from "./permissionless/sale-listing/sale-detail/SaleDetail.svelte";
    import { onMount } from 'svelte'
    onMount(() => {
        window.scrollTo(0, 0);
    });

    const routes = {
        "/landing-page": LandingPage,
        "/": ProjectListing,
        '/explore-projects/:id': ExploreProjects,
        "/permissionless": Permissionless,
        "/permissionless/:projectId": Permissionless,
        "/project-details/:projectId/:address?": ProjectPreview,
        "/sale-listing": SaleListing,
        "/sale-detail/:projectId/:address": SaleDetail,
    }
    let isWrongChain = false
    let modalStatus = false;
    const modalAction = () => {
        modalStatus = !modalStatus
    }

    chainId.subscribe(() => {
        if($chainId){
            const chainNumber = typeof $chainId === "number" ? $chainId : parseInt($chainId, 16)
            isWrongChain = !(chainNumber === SUPPORTED_CHAIN)
        }
    })

    onMount(async () => {
        if(window.ethereum){
            const accounts = await window.ethereum.request({
                method: 'eth_accounts'
            });

            if(accounts.length)
                defaultEvmStores.setBrowserProvider().catch(() => {})

            window.ethereum.on('accountsChanged', () => window.location.reload())

        }
    })

</script>
<div class="launchpad-wrapper flex">
    <div class="content-wrapper">
        <Header on:modalAction={modalAction}/>
        <div class="inner-content-wrapper">
            <Loader/>
            {#if isWrongChain}
                <ChainModal/>
            {/if}
            <Router {routes} />
            <ParticipateModal {modalStatus} on:modalAction={modalAction}/>
        </div>
        <Footer/>
    </div>
</div>
<style>
    .launchpad-wrapper { width: 100%;
        overflow: hidden;}
    .content-wrapper {
        padding-top: 116px;
        width: 100%;
    }
    .inner-content-wrapper {
        max-width: 1536px;
        width: 100%;
        margin: 0 auto;
        padding: 0 15px;
    }
</style>
